import { Pin, PinOff } from "lucide-react";
import { useShellSidebar } from "../../stores/shell-sidebar";

/** Tab-bar height control aligned with the nav sidebar column below. */
export function SidebarPinToggle() {
  const pinned = useShellSidebar((s) => s.pinned);
  const togglePinned = useShellSidebar((s) => s.togglePinned);

  return (
    <div
      className="flex shrink-0 items-stretch justify-center border-r border-line bg-surface-2 transition-[width] duration-200 ease-out"
      style={{
        width: pinned ? "var(--nav-sidebar-expanded-width)" : "var(--nav-sidebar-width)",
        height: "var(--tabbar-height)",
      }}
    >
      <button
        type="button"
        aria-label={pinned ? "Unpin sidebar (hover to expand)" : "Pin sidebar open"}
        title={pinned ? "Hover mode" : "Pin sidebar"}
        aria-pressed={pinned}
        className={`flex w-full items-center justify-center transition-colors hover:bg-hover ${
          pinned ? "text-brand-pink" : "text-muted hover:text-foreground"
        }`}
        onClick={togglePinned}
      >
        {pinned ? <Pin size={16} className="fill-current" /> : <PinOff size={16} />}
      </button>
    </div>
  );
}
